import { isEventMuted } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/useEventCardState";
import {
  isEventSeen,
  isRecentlyChanged,
} from "features/CenterContent/RoleContent/EventHandling/utils";
import { PlanEventInformation } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";

const isClosed = (information: CombinedHistoryResponse) =>
  information.state === "CLOSED";

const isNotifying = (information: CombinedHistoryResponse) => {
  if (isClosed(information)) return false;

  return !isEventMuted(information.uuid);
};

const isChanged = (information: CombinedHistoryResponse) =>
  information.version > 1 &&
  !isEventSeen(information.uuid, information.version) &&
  isRecentlyChanged(information);

export const useHeaderCount = (
  measures: PlanEventInformation[] | undefined,
  includeClosed: boolean,
  shouldNotify: boolean,
) => {
  if (!measures)
    return { count: 0, notifyingOrChangedCount: 0, notifying: false };

  const count = measures.filter(
    ({ information }) => includeClosed || !isClosed(information),
  ).length;

  const notifyingOrChangedCount = measures.filter(({ information }) => {
    if (isClosed(information)) return false;

    return isChanged(information) || (shouldNotify && isNotifying(information));
  }).length;

  const notifying =
    shouldNotify &&
    measures.some(({ information }) => isNotifying(information));

  return { count, notifyingOrChangedCount, notifying };
};
